import {
  AuditByQuizIdRequestParams,
  getAuditByQuizId,
} from "@/requests/audits/audit-by-quiz-id.request";
import { useQuery } from "@tanstack/react-query";

export const buildAuditByQuizIdQueryKey = (
  params: AuditByQuizIdRequestParams,
) => ["companies", params.companyId, "quizzes", params.quizId, "audit"];

export const useAuditByQuizId = (variables: AuditByQuizIdRequestParams) => {
  return useQuery({
    queryKey: buildAuditByQuizIdQueryKey(variables),
    queryFn: () => getAuditByQuizId(variables),
    enabled: !!variables.companyId && !!variables.quizId,
  });
};
